












































import {  Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';

@Component
export default class CopyInput extends mixins(PlanLimitsMixin) {
  // check, probably move to ui components
  copied: boolean = false;
  
  @Prop() 
  placeholder: string;

  @Prop({default: false })
  isMini: boolean;

  @Prop() 
  value: string;

  @Prop() 
  label: string;

  @Prop() 
  labelHelp: string;

  @Prop()
  planLimits: keyof BillingLimits;

  copy() {
    if(this.showPlanLimitsIcon){
      return this.handleClickPlanLimits()
    }
    if (!this.value) return;

    //@ts-ignore
    let input = this.$refs.input.$el.querySelector('input');
    input.select();
    document.execCommand('copy');
    this.copied = true;
    setTimeout(() => (this.copied = false), 1500);
  }
  
  get preparedValue(){
    if(this.showPlanLimitsIcon){
      return '*******************************'
    }
    return this.value
  }
}
